export const consentSuccess = {
  redirect_to: 'http://localhost:3003/user/login',
};
